import React from "react"
import SettingsIntermediate from "../SettingsIntermediate"
import userPermissions from "../../User/Permissions"
import { getSession } from "../../../auth"
import { Box, Alert } from "@mui/material"
import Auth2FA from "../../Settings/Auth2FA"

const AuthPage = () => {
    const groups = userPermissions()
    const enterprise = getSession()?.profile?.enterprise
    return (
        <>
            {enterprise.has_2fa_auth
                ? <SettingsIntermediate title="Autenticação 2FA" components={() => ({
                        comp1: {
                            permissions: true,
                            style: "title",
                            label: "Autenticação 2FA"
                        },
                        comp2: {
                            permissions: groups.isAdmin && enterprise.has_2fa_auth,
                            style:"list",
                            label:"Canais 2FA",
                            sublabel: "Escolha um ou mais canais por onde enviar o código de acesso.",
                            redirect: (<Auth2FA enterpriseId={enterprise?.id} />)
                        }
                    })
                } />
                : <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                    <Box sx={{ fontSize: "1.5em", fontWeight: "bold", color: "#21446c" }}>Autenticação 2FA</Box>
                    <Alert severity="info">
                        Entre em contato com seu gerente de contas para contratar a Autenticação em Dois Fatores Kwik <a href="https://wa.link/0bs73j">Clique aqui.</a>
                    </Alert>
                </Box>
            }
        </>
    )
}


export default AuthPage
